module.exports = __webpack_public_path__ + "static/media/product-teamviewer-mobile-device-support.423d4ac3.jpg";